import React from 'react';
import LeafletMapComponent from "components/map/LeafletMapComponent";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import IconTitleValue from "components/textValue/IconTitleValue";
import messages from "res/messages/farsi";
import CustomCheckBox from "components/checkBox/CustomCheckBox";

import ICUserAccount from 'res/images/user.png';
import ICEdit from 'res/images/edit_white.png';
import ICDelete from 'res/images/delete_white.png';
import ICPhone from "res/images/phone.png";
import ICAddress from 'res/images/address.png';

export default function Address(props) {

    let address = props.address
    let latitude = 0
    let longitude = 0
    if (address.lat_long) {
        let locations = address.lat_long.split(",")
        latitude = parseFloat(locations[0])
        longitude = parseFloat(locations[1])
    }

    if (address.isTemp) {
        return (<div className="fullWidth"/>)
    } else {
        return (
            <div style={{height: "27em"}} className="card_gray card marginSmall">
                <div className="card_blue_top_curve mediumTextBold fullWidth">
                    <CustomCheckBox
                        checkboxcolor={"var(--white)"}
                        height={"1em"}
                        checked={address.is_default}
                        onClick={() => {
                            props.onSetDefaultAddress(address)
                        }}/>
                    <label className="clickable whiteColor">
                        {address.addrees_name}
                    </label>
                </div>
                <div className="marginSmall highZIndex_0" style={{height: "10em", position: "relative"}}>
                    <LeafletMapComponent
                        isStatic={true}
                        isFirstLode={true}
                        center={{
                            latitude: latitude,
                            longitude: longitude,
                        }}
                        markers={[{
                            latitude: latitude,
                            longitude: longitude,
                            icon: "https://sarfe.bpc.ir/image/catalog/Standard%20Banner/home.png"
                        }]}
                    />
                </div>
                <IconTitleValue
                    icon={<img src={ICUserAccount} alt="" className="xxSmallIcon"/>}
                    title={messages.deliverTakeName}
                    value={address.full_name}/>
                <IconTitleValue
                    icon={<img src={ICPhone} alt="" className="xxSmallIcon"/>}
                    title={messages.deliverTakePhone}
                    value={address.telephone}/>
                <IconTitleValue
                    maxLength={70}
                    icon={<img src={ICAddress} alt="" className="xxSmallIcon"/>}
                    title={messages.fullAddress}
                    value={address.address}/>
                <div className="horizontalScreen"
                     style={{position: "absolute", bottom: "0.5em", left: "0.5em"}}>
                    <div>
                        <IconTitleButtonRound
                            height="2.5em"
                            direction="ltr"
                            fontSize="smallTextBold"
                            onClick={() => {
                                props.onEditAddress(address)
                            }}
                            icon={<img src={ICEdit} alt="" className="xxSmallIcon"/>}
                            title={messages.editAddress}/>
                    </div>
                    <div className="marginRightSmall">
                        <IconTitleButtonRound
                            height="2.5em"
                            direction="ltr"
                            fontSize="smallTextBold"
                            onClick={() => {
                                props.onDeleteAddress(address)
                            }}
                            icon={<img src={ICDelete} alt="" className="xxSmallIcon"/>}
                            title={messages.deleteAddress}/>
                    </div>
                </div>
            </div>
        )
    }

}